var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.alertMessage
      ? _c(
          "div",
          {
            staticClass: "alert trial-alert-expiry alert-dismissible fade show",
            class: _vm.alertColor,
            attrs: { role: "alert" },
          },
          [
            _c("div", {
              staticClass: "alert-message",
              domProps: { innerHTML: _vm._s(_vm.alertMessage) },
            }),
            !_vm.inBillingProfilePage
              ? _c(
                  "a",
                  {
                    staticClass: "trial-upgrade-btn",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.redirectUser($event)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("pages.dashboardLayout.upgradeNow")) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm.licenseMessage
      ? _c(
          "div",
          {
            staticClass: "alert trial-alert-expiry alert-danger",
            attrs: { role: "alert" },
          },
          [
            _vm._v("\n        " + _vm._s(_vm.licenseMessage) + "\n        "),
            _c("MailToSupport"),
            _vm._v("\n        " + _vm._s(_vm.licenseMessagePart2) + "\n    "),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }